import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdEmail, MdLockOutline } from 'react-icons/md';
import { FaSignInAlt } from 'react-icons/fa';
import Swal from 'sweetalert2';
import './ad.css'



const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

// const handleLogin = async (e) => {
//   e.preventDefault();

//   try {
//     const response = await fetch('https://api.garudasena.org/admin/login', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ email, password }),
//     });

//     const data = await response.json();

//     if (response.ok) {
//       sessionStorage.setItem('isAdminLoggedIn', 'true');
//       sessionStorage.setItem('adminEmail', data.adminEmail);

//       Swal.fire({
//         title: 'Success!',
//         text: 'Admin login successful!',
//         icon: 'success',
//         confirmButtonText: 'Okay',
//         customClass: {
//           popup: 'swal-popup-success',     
//           title: 'swal-title',              
//           content: 'swal-content',          
//           confirmButton: 'swal-confirm-button', 
//         },
//       });

//       navigate('/admin-dashboard');
//     } else {
//       setError(data.message);
//       Swal.fire({
//         title: 'Error!',
//         text: data.message,
//         icon: 'error',
//         confirmButtonText: 'Try Again',
//         customClass: {
//           popup: 'swal-popup-error',     
//           title: 'swal-title-error',      
//           content: 'swal-content-error', 
//           confirmButton: 'swal-confirm-button-error',
//         },
//       });
//     }
//   } catch (error) {
//     setError('An error occurred. Please try again.');
//     Swal.fire({
//       title: 'Oops!',
//       text: 'An error occurred. Please try again.',
//       icon: 'error',
//       confirmButtonText: 'Try Again',
//       customClass: {
//         popup: 'swal-popup-error',       
//         title: 'swal-title-error',     
//         content: 'swal-content-error',   
//         confirmButton: 'swal-confirm-button-error', 
//       },
//     });
//   }
// };




const handleLogin = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('https://api.garudasena.org/admin/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (response.ok) {
      sessionStorage.setItem('isAdminLoggedIn', 'true');
      sessionStorage.setItem('adminEmail', data.adminEmail);

      // SweetAlert Success
      Swal.fire({
        title: 'Success!',
        text: 'Admin login successful!',
        icon: 'success',
        confirmButtonText: 'Okay',
        customClass: {
          popup: 'swal-popup-success',     
          title: 'swal-title',              
          content: 'swal-content',          
          confirmButton: 'swal-confirm-button', 
        },
      });

      navigate('/admin-dashboard');
    } else {
      setError(data.message);
      
      // SweetAlert Error
      Swal.fire({
        title: 'Error!',
        text: data.message,
        icon: 'error',
        confirmButtonText: 'Try Again',
        customClass: {
          popup: 'swal-popup-error',     
          title: 'swal-title-error',      
          content: 'swal-content-error', 
          confirmButton: 'swal-confirm-button-error',
        },
      });
    }
  } catch (error) {
    setError('An error occurred. Please try again.');
    
    // SweetAlert Oops Error
    Swal.fire({
      title: 'Oops!',
      text: 'An error occurred. Please try again.',
      icon: 'error',
      confirmButtonText: 'Try Again',
      customClass: {
        popup: 'swal-popup-error',       
        title: 'swal-title-error',     
        content: 'swal-content-error',   
        confirmButton: 'swal-confirm-button-error', 
      },
    });
  }
};





  return (
    <div style={styles.container}>
      <div style={styles.card}>
      <div style={styles.logoContainer}>
  <div style={styles.logoLine}>
    <span style={styles.logoMain}>GARUDA</span>
    <span style={styles.logoAccent}>SENA</span>
  </div>
 <h1 style={styles.mainTitle}>Volunteer Admin Login</h1>
</div>

<div style={styles.header}>
 
  <p style={styles.subTitle}>
    Manage registrations, seva activities & volunteers
  </p>
</div>


        <form onSubmit={handleLogin}>
          <div style={styles.inputWrapper}>
            <MdEmail style={styles.icon} />
            <input
              type="email"
              placeholder="Admin Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={styles.input}
            />
          </div>

          <div style={styles.inputWrapper}>
            <MdLockOutline style={styles.icon} />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={styles.input}
            />
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <button type="submit" style={styles.button}>
            <FaSignInAlt style={{ marginRight: '8px' }} />
            Sign In
          </button>
        </form>
      </div>
    </div>
  );
};



const styles = {
  container: {
    height: '100vh',
    background: 'linear-gradient(135deg, #faf5ee 20%, #fff8e1 80%)', // soft cream tones
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
  },

  card: {
    background: '#ffffff',
    border: '1px solid rgba(242, 201, 76, 0.4)', // subtle golden border
    borderRadius: '14px',
    boxShadow: '0 8px 25px rgba(123, 30, 58, 0.15)',
    maxWidth: '420px',
    width: '100%',
    padding: '2.5rem 2rem',
    color: '#4a2b2b',
    textAlign: 'center',
  },

  logoMain: {
    fontSize: '1.9rem',
    fontWeight: '800',
    color: '#7b1e3a',
    letterSpacing: '1px',
  },
  logoAccent: {
    fontSize: '1.9rem',
    fontWeight: '800',
    color: '#d19a01',
    letterSpacing: '2px',
  },
  logoTagline: {
    fontSize: '0.9rem',
    fontWeight: '500',
    color: '#7b1e3a',
    marginTop: '6px',
    fontStyle: 'italic',
  },

  mainTitle: {
    fontSize: '1.4rem',
    fontWeight: '700',
    color: '#7b1e3a',
    marginBottom: '0.4rem',
    marginTop: '1rem',
  },
  subTitle: {
    fontSize: '0.9rem',
    color: '#a06100',
    marginBottom: '2rem',
  },

  inputWrapper: {
    position: 'relative',
    marginBottom: '1.3rem',
  },
  icon: {
    position: 'absolute',
    top: '12px',
    left: '14px',
    color: '#a06100',
    fontSize: '18px',
  },
  input: {
    width: '85%',
    padding: '12px 12px 12px 42px',
    borderRadius: '8px',
    border: '1px solid #e8d8b0',
    background: '#fffaf0',
    color: '#4a2b2b',
    fontSize: '15px',
    outline: 'none',
    transition: 'border-color 0.3s ease, background 0.3s ease',
  },
  inputFocus: {
    borderColor: '#f2c94c',
  },
  error: {
    color: '#c43b3b',
    marginBottom: '1rem',
    fontSize: '0.9rem',
    fontWeight: '500',
  },

  button: {
    width: '100%',
    padding: '12px',
    background: '#7b1e3a',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    fontSize: '15px',
    cursor: 'pointer',
    boxShadow: '0 5px 12px rgba(123, 30, 58, 0.3)',
    transition: 'background 0.3s ease, transform 0.2s ease',
  },
  buttonHover: {
    background: '#a43d56',
    transform: 'translateY(-1px)',
  },
};





export default AdminLogin;
